<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useTimeoutFn } from "@vueuse/core"
import { useI18n } from "vue-i18n"

// ================================
// I18N
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            pvDim: {
                finish: {
                    success: "Création finalisée",
                    error: "Une erreur est survenue lors de la création de l'analyse",
                    close: "Quitter",
                },
            },
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        failure?: boolean
    }>(),
    {
        failure: false,
    }
)

const emit = defineEmits<{
    (event: "click:close"): void
}>()

// ================================
// INTERACTIONS
// ================================
function onEmitClose(): void {
    emit("click:close")
}

if (!props.failure) {
    useTimeoutFn(onEmitClose, 2000)
}
</script>

<template>
    <section
        class="pv-form-finish flex flex-col items-center justify-center gap-6 py-8"
    >
        <div
            class="flex items-center gap-3 text-center"
            :class="failure ? 'text-red-600' : 'text-green-600'"
        >
            <i
                class="pi text-xl"
                :class="failure ? 'pi-times-circle' : 'pi-check-circle'"
            />
            <p class="font-medium">
                {{
                    failure
                        ? t("pvDim.finish.error")
                        : t("pvDim.finish.success")
                }}
            </p>
        </div>

        <BaseButton
            type="button"
            outlined
            :label="t('pvDim.finish.close')"
            @click="onEmitClose"
        />
    </section>
</template>
